<template>
  <div id="password" class="row vh-100">
    <div class="col-12 col-lg-6 px-0 d-flex align-items-center left">
      <div class="container">
        <div class="row">

          <div class="col-12 text-center mb-5">
            <h4 class="font-weight-bold">Reset Password</h4>
          </div>

          <form class="col-12">
            <div class="container padding-form">
              <div class="row shadow rounded py-3">
                <div class="col-12 d-flex justify-content-center mb-5">
                  <img width="25%" src="../assets/images/home/PayMe4Cargo-01.png" alt="">
                </div>
                <div class="col-12" v-show="statusMessage">
                  <b-alert variant="success" show class="capitalize">{{ statusMessage }}</b-alert>
                </div>
                <div class="col-12">
                  <div class="form-group px-5">
                    <b-alert v-model="ifError" variant="danger">{{email_message}}</b-alert>
                    <p class="mb-1 font-weight-bold">Email</p>
                    <input type="text" class="form-control" v-model="email" placeholder="Enter your email or phone number">
                  </div>
                </div>
                <div class="col-12 d-flex justify-content-center mt-4 mb-5">
                  <button class="btn btn-success px-5" type="submit" @click.prevent="doForgotPassword">
                    <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
                    <span v-else>Reset Password</span>
                  </button>
                </div>
                <div class="col-12 text-center mt-5">
                  <p class="mb-0 font-weight-bold">Remember Your Password?
                    <a class="text-primary" href="#" @click="login">
                     Login
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="col-6 d-none d-lg-inline right">
      <div class="row">
        <div class="col-12">
          <div class="container">
            <ul class="vh-100 d-flex flex-column justify-content-center px-5">
              <li class="text-white"><h4 class="mb-4 font-weight-bold text-white">Easy and simple payments in any currency for logistic vendors.</h4></li>
              <li class="text-white"><h4 class="mb-0 font-weight-bold text-white">Never get stuck making a payment at the bank, Get your client's cargo released instantly.</h4></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store';
import TransactionAPI from '../api/transactions_api';

export default {
  data() {
    return {
      email: null,
      email_message: '',
      ifError: false,
      loading: false,
      statusMessage: ''
    };
  },
  computed: {
    forgot_password: {
      get: function () {
        return store.state.forgot_password;
      },
      set: function (newValue) {
        store.state.forgot_password = newValue;
      }
    }
  },
  props: ['session'],
  mounted() {
    this.ifError = false
    this.email = ''
  },
  methods: {    
    login() {
      this.$router.push('/login', () => {});
    },
    emailChecker(email) {
      const check = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const result = check.test(email);
      return result;
    },
    doForgotPassword() {
      var self = this;

      if (this.email) {
        if (this.emailChecker(this.email)) {
          this.loading = true
          const payload = {
            email: this.email
          }
          TransactionAPI.methods.doForgotPassword(payload)
          .then(result => {
            console.log('success', self.forgot_password);
            self.statusMessage = self.forgot_password.data.message;
            self.loading = false;
          })
          .catch(error => {
            console.log(error)
            self.loading = false;
          })
        } else {
          this.ifError = true
          this.email_message = 'Please enter an valid email'
        }
      } else {
        this.ifError = true
        this.email_message = 'Please enter an email'
      }
    }
  },
};
</script>
<style scoped>
.right {
  background-image: url("../assets/images/signin/login-background.jpg");
  background-repeat: no-repeat;
}
.padding-form {
  padding-left: 100px;
  padding-right: 100px;
}
.capitalize {
  text-transform: capitalize;
}
</style>
